import { Observable } from "rxjs"
import { ObservableFromFetch } from "../ObservableFromFetch"
import { AccountTypeID } from "../../config/Constants"
import AutoFilterRegion from "./Model/AutoFilterRegion"

export default function AutoFilterRegionsGetObservable(company: number, filter: string): Observable<AutoFilterRegion[]> {
  const requestBody: string = JSON.stringify({
    AccountType: AccountTypeID,
    ParentAccountID: company,
    AutoFilterValue: filter,
    IsFilters: true
  })

  return ObservableFromFetch<AutoFilterRegion[]>("Order/GetAutoFilterRegion", requestBody)
}
